module.exports = __webpack_public_path__ + "img/hero_image_events_mobile.8ecc844.jpg";